import { render, staticRenderFns } from "./corp.vue?vue&type=template&id=87f2ef3c&scoped=true"
import script from "./corp.vue?vue&type=script&lang=js"
export * from "./corp.vue?vue&type=script&lang=js"
import style0 from "./corp.vue?vue&type=style&index=0&id=87f2ef3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f2ef3c",
  null
  
)

export default component.exports